function parallaxScrollAnimation(e) {
    const triggerClassNames = {
        main: "parallax",
        background: function() {
            return this.main + "--background"
        },
        foreground: function() {
            return this.main + "--foreground"
        },
        midground: function() {
            return this.main + "--midground"
        }
    };

    const foregroundSpeed = 0.05;
    const midgroundSpeed = 0.6;

    document.querySelectorAll(`.${triggerClassNames.main}`).forEach(function(element) {
        const yCoord = window.scrollY;

        element.style.top = yCoord * foregroundSpeed + "px";

        switch (element.classList) {
            case triggerClassNames.foreground:
                
                break;
            default:
                break;
        }        

    });
};

if(!!window) 
    window.addEventListener("scroll", parallaxScrollAnimation);
else 
    alert("Window isn't defined");